import request from '@/utils/request';

//获取文件模板名称和类型
export function getNameAndType(data) {
  return request.post('admin/file-template/name-type', data);
}
export function getTemplateList(data) {
  return request.post('admin/file-template/list', data);
}
//修改文件模板状态
export function changeTemplateStatus(data) {
  return request.post('admin/file-template/status', data);
}

//文件模板新增
export function addFileTemplate(data) {
  return request.post('admin/file-template/store', data);
}
//文件模板编辑
export function editFileTemplate(data) {
  return request.post('admin/file-template/edit', data);
}

//获取文件模板详情
export function getFileTemplateDetail(data) {
  return request.post('admin/file-template/detail', data);
}

//获取文件模板数据源
export function getTemplateDataSources(data) {
  return request.post('admin/container-template/data-source', data);
}

//获取容器模板资源
export function getContainerTemplate(data) {
  return request.post('admin/container-template/resource', data);
}